import { Dispatch, SetStateAction, useState } from 'react';

import Input from '@/components/basicComponents/input';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { IListDataWithId } from '@/components/dealPipeline-page/modify/types';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface CreateStrategyProps {
  isOpen: boolean;
  setStrategies: Dispatch<SetStateAction<IListDataWithId>>;
  onClose: () => void;
}

const CreateStrategy = ({ isOpen, setStrategies, onClose }: CreateStrategyProps) => {
  const [value, setValue] = useState('');

  const saveValue = () => {
    setStrategies((prevStrategies) => {
      const isValueExistInList = prevStrategies.list.some((strategy) => strategy.value === value);
      const isValueExistInAllList = prevStrategies.allList.some((strategy) => strategy.value === value);
      return {
        ...prevStrategies,
        ...(!isValueExistInList && { list: [...prevStrategies.list, createSimpleSelectOption(value)] }),
        ...(!isValueExistInAllList && { allList: [...prevStrategies.allList, createSimpleSelectOption(value)] })
      };
    });

    setStrategies((prevStrategies) => {
      if (!prevStrategies.list.length) {
        return {
          ...prevStrategies,
          selected: [...new Set([...prevStrategies.selected, value])]
        };
      }

      let duplicateStrategy: string | null = null;

      const updatedStrategies = prevStrategies.selected.map((strategy) => {
        if (strategy === '') {
          return value;
        }
        if (strategy === value) {
          duplicateStrategy = value;
          return value;
        }
        return strategy;
      });

      return { ...prevStrategies, selected: updatedStrategies, duplicate: duplicateStrategy };
    });

    setTimeout(() => {
      setStrategies((prevStrategies) => {
        return {
          ...prevStrategies,
          duplicate: null,
          selected: [...new Set(prevStrategies.selected)]
        };
      });
    }, 1000);
    onClose();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value.length
      }}
      showRequiredFields
    >
      <ModalContainer>
        <ModalTitel>Create New Strategy</ModalTitel>
        <ModalDescription>Use strategies to categorize investments by sector or other dimensions useful for investor allocation.</ModalDescription>
      </ModalContainer>
      <ManagerInputWrapper>
        <Input
          label="Strategy"
          placeholder="Provide a strategy"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          type="text"
          size="lg"
          isRequiredField
          autoFocus
        />
      </ManagerInputWrapper>
    </ModalWrappedContent>
  );
};

export default CreateStrategy;

const ModalContainer = styled.div`
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
`;

const ManagerInputWrapper = styled.div`
  padding-top: 35px;
`;
